<template>
  <div class="evaluation-results-section">
    <div class="box">
      <h4 class="title is-4 mb-4">
        <i class="fa fa-chart-line mr-2"></i>
        {{ $t("evaluation results") }}
      </h4>

      <!-- Evaluation Details -->
      <div v-if="hasEvaluationDetail">
        <EvaluationDetailsTable
          :evaluationDetails="evaluation.evaluation_detail"
        />
      </div>

      <!-- No Results Message -->
      <div v-else class="notification is-info">
        <i class="fa fa-info-circle mr-2"></i>
        {{ $t("no evaluation result available") }}
      </div>

      <!-- Comments Section -->
      <CommentsSection
        v-if="evaluation.comments"
        :comments="evaluation.comments"
      />
    </div>
  </div>
</template>

<script>
import EvaluationDetailsTable from "./EvaluationDetailsTable.vue";
import CommentsSection from "./CommentsSection.vue";

export default {
  name: "EvaluationResultsSection",

  components: {
    EvaluationDetailsTable,
    CommentsSection,
  },

  props: {
    evaluation: {
      type: Object,
      required: true,
    },
    hasEvaluationDetail: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.evaluation-results-section {
  margin-bottom: 1.5rem;
}

.title {
  color: hsl(0, 0%, 96%) !important;
}

.notification {
  background-color: hsl(0, 0%, 21%);
  color: hsl(0, 0%, 96%);
  border: 1px solid hsl(0, 0%, 42%);
}

.notification.is-info {
  background-color: rgba(50, 115, 220, 0.1);
  color: hsl(229, 53%, 71%);
  border-color: hsl(229, 53%, 71%);
}

.mr-2 {
  margin-right: 0.5rem;
}

.mb-4 {
  margin-bottom: 1rem;
}
</style>
